import { Keyboard, createShortcuts, stringifyKey, filterInputEvent } from 'keyboard-manager';

export const keyboard = new Keyboard();

window.addEventListener('keydown', keyboard.getHandler(), false);

export { createShortcuts, stringifyKey, filterInputEvent };
